'use strict';

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var CID = require('cids');

var withIs = require('class-is');

var _require = require('buffer'),
    Buffer = _require.Buffer; // Link represents an IPFS Merkle DAG Link between Nodes.


var DAGLink = /*#__PURE__*/function () {
  function DAGLink(name, size, cid) {
    _classCallCheck(this, DAGLink);

    if (!cid) {
      throw new Error('A link requires a cid to point to');
    } // assert(size, 'A link requires a size')
    //  note - links should include size, but this assert is disabled
    //  for now to maintain consistency with go-ipfs pinset


    Object.defineProperties(this, {
      Name: {
        value: name || '',
        writable: false,
        enumerable: true
      },
      Tsize: {
        value: size,
        writable: false,
        enumerable: true
      },
      Hash: {
        value: new CID(cid),
        writable: false,
        enumerable: true
      },
      _nameBuf: {
        value: null,
        writable: true,
        enumerable: false
      }
    });
  }

  _createClass(DAGLink, [{
    key: "toString",
    value: function toString() {
      return "DAGLink <".concat(this.Hash.toBaseEncodedString(), " - name: \"").concat(this.Name, "\", size: ").concat(this.Tsize, ">");
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      if (!this._json) {
        this._json = Object.freeze({
          name: this.Name,
          size: this.Tsize,
          cid: this.Hash.toBaseEncodedString()
        });
      }

      return Object.assign({}, this._json);
    } // Memoize the Buffer representation of name
    // We need this to sort the links, otherwise
    // we will reallocate new buffers every time

  }, {
    key: "nameAsBuffer",
    get: function get() {
      if (this._nameBuf !== null) {
        return this._nameBuf;
      }

      this._nameBuf = Buffer.from(this.Name);
      return this._nameBuf;
    }
  }]);

  return DAGLink;
}();

exports = module.exports = withIs(DAGLink, {
  className: 'DAGLink',
  symbolName: '@ipld/js-ipld-dag-pb/daglink'
});